import React, { useState } from 'react';
import { Button } from '../../Button';
import AsideMenu from '../../AsideMenu/AsideMenu';
import { useTheme } from '../../../contexts/Theme/ThemeContext';
import {
  OrdenacaoConfig,
  OrdenacaoProduto,
  OrdenacaoVariacao,
  opcoesProduto,
  opcoesVariacao,
  salvarOrdenacao,
} from './ordenacaoUtils';
import {
  OrdenacaoContainer,
  SectionTitle,
  ChipContainer,
  Chip,
  OrdenacaoHeader,
} from './ordenacaoStyles';

interface OrdenacaoButtonProps {
  ordenacao: OrdenacaoConfig;
  onOrdenacaoChange: (ordenacao: OrdenacaoConfig) => void;
}

const OrdenacaoButton: React.FC<OrdenacaoButtonProps> = ({
  ordenacao,
  onOrdenacaoChange,
}) => {
  const { theme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [tempOrdenacao, setTempOrdenacao] = useState<OrdenacaoConfig>(ordenacao);

  const handleOpen = () => {
    setTempOrdenacao(ordenacao);
  };

  const handleAplicar = () => {
    onOrdenacaoChange(tempOrdenacao);
    salvarOrdenacao(tempOrdenacao);
  };

  const handleCancelar = () => {
    setTempOrdenacao(ordenacao);
  };

  const handleProdutoClick = (value: OrdenacaoProduto) => {
    setTempOrdenacao((prev) => ({
      ...prev,
      produto: prev.produto === value ? null : value,
    }));
  };

  const handleVariacaoClick = (value: OrdenacaoVariacao) => {
    setTempOrdenacao((prev) => ({
      ...prev,
      variacao: prev.variacao === value ? null : value,
    }));
  };

  // Verifica se há alguma ordenação ativa
  const temOrdenacaoAtiva = ordenacao.produto !== null || ordenacao.variacao !== null;

  return (
    <OrdenacaoHeader>
      <div className="fonteTexto">
        <Button
          title={'Ordenar produtos e variações'}
          onClick={() => setIsOpen(true)}
        />
      </div>
      <AsideMenu
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        titulo="Ordenação"
        subtitulo="Ordenar produtos e variações"
        onAplicar={handleAplicar}
        onCancelar={handleCancelar}
        onOpen={handleOpen}
      >
        <OrdenacaoContainer>
          <div>
            <SectionTitle theme={theme}>Ordenar os produtos</SectionTitle>
            <ChipContainer>
              {opcoesProduto.map((opcao) => (
                <Chip
                  key={opcao.value}
                  theme={theme}
                  selected={tempOrdenacao.produto === opcao.value}
                  onClick={() => handleProdutoClick(opcao.value)}
                  type="button"
                >
                  {opcao.label}
                </Chip>
              ))}
            </ChipContainer>
          </div>

          <div>
            <SectionTitle theme={theme}>Ordenar as variações</SectionTitle>
            <ChipContainer>
              {opcoesVariacao.map((opcao) => (
                <Chip
                  key={opcao.value}
                  theme={theme}
                  selected={tempOrdenacao.variacao === opcao.value}
                  onClick={() => handleVariacaoClick(opcao.value)}
                  type="button"
                >
                  {opcao.label}
                </Chip>
              ))}
            </ChipContainer>
          </div>
        </OrdenacaoContainer>
      </AsideMenu>
    </OrdenacaoHeader>
  );
};

export default OrdenacaoButton;
